import { Checkbox, Radio } from "antd";
import React from "react";
import { Button, Col, Row, Spinner } from "reactstrap";
import { DropdownLabel } from "../dropdown/DropdownLabel";
import FormInput from "../formInput/FormInput";

const Carrier = ({
  toggle,
  account,
  setAccount,
  servicesData,
  setServiceType,
  setPackageType,
  onPressCreateLabel,
  labelLoading,
  setServiceCode,
  carrier,
  setShippingCost,
  paymentMethod,
  setPaymentMethod,
  signatureRequired,
  setSignatureRequired,
}) => {
  const onSelectShipment = (index, item) => {
    const cost = item?.children?.split(" ")[0];
    setShippingCost(cost);
    if (carrier === "FEDEX") {
      setPackageType(servicesData[index]?.packagingType);
      setServiceType(
        servicesData[index]?.serviceType ?? servicesData[index]?.serviceName
      );
    } else if (carrier === "UPS") {
      setServiceCode(servicesData[index]?.serviceCode);
      setServiceType(servicesData[index]?.serviceName);
    } else {
      setServiceCode(servicesData[index]?.serviceCode);
      setServiceType(servicesData[index]?.serviceName);
    }
  };

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleSignatureChange = (e) => {
    setSignatureRequired(e.target.checked);
  };

  return (
    <div>
      <Row className="align-items-center">
        <Col md={5} className="mb-3">
          <p className="fw-bold">Select Service</p>
          <DropdownLabel
            object_key={"rates"}
            placeholder={"Select Service"}
            options={servicesData}
            width="100%"
            onSelect={onSelectShipment}
          />
        </Col>
        <Col md={3}>
          <FormInput
            type={"text"}
            label={"Account"}
            placeholder={"Account"}
            value={account}
            handleChange={(e) => setAccount(e.target.value)}
          />
        </Col>

        <Col md={3}>
          <div className="d-flex justify-content-center align-items-start flex-column">
            <Radio.Group
              onChange={handlePaymentMethodChange}
              value={paymentMethod}
              className="d-flex flex-column"
            >
              <Radio value="THIRD_PARTY">Third Party</Radio>
              <Radio value="RECIPIENT">Bill Receiver</Radio>
            </Radio.Group>
            <Checkbox
              checked={signatureRequired}
              onChange={handleSignatureChange}
            >
              Signature Requirement
            </Checkbox>
          </div>
        </Col>
      </Row>
      <div className="d-flex justify-content-end gap-3">
        <Button
          style={{ width: "200px" }}
          className=" bg-white text-primary border border-primary "
          onClick={toggle}
        >
          Cancel
        </Button>
        <Button
          style={{ width: "200px" }}
          className="border-0 bg-primary-color"
          onClick={onPressCreateLabel}
          disabled={labelLoading}
        >
          {labelLoading ? <Spinner size={"sm"} /> : "Create Label"}
        </Button>
      </div>
    </div>
  );
};

export default Carrier;
